import React from 'react'
import { useDispatch } from 'react-redux'
import Page from '../../components/Page'
import style from './style'
// material
import { styled } from '@material-ui/core/styles'
import { Container, withStyles } from '@material-ui/core'
import SuccessCode from './success'
import { track } from '@amplitude/analytics-browser'
const RootStyle = styled(Page)(({ theme }) => ({
  minHeight: '100%',
  paddingTop: theme.spacing(5),
  paddingBottom: theme.spacing(10),
}))

// ----------------------------------------------------------------------

function SubscriptionSuccess(props) {
  const dispatch = useDispatch()
  const { classes, history } = props
  track('payment_success')
  return (
    <RootStyle title="Pricing">
      <Container maxWidth="lg">
        <SuccessCode history={history} dispatch={dispatch} />
      </Container>
    </RootStyle>
  )
}

export default withStyles(style)(SubscriptionSuccess)
